export default __webpack_public_path__ + "static/media/055-india.45078962.svg";